import { ApiCrud } from 'adready-api/api/api-crud';
import http from 'adready-api/api/http';

const flipPixelsFileApi = new ApiCrud(http.AXIOS, {
  dumpToBucket: 'POST flipPixelsFile/dumpToBucket',
});

export default flipPixelsFileApi;
